import { Storage } from "aws-amplify"
import config from "../config"

Storage.configure({
	AWSS3: {
		bucket: config.s3.bucket,
		region: config.s3.region
	}
})
export const getFiles = async (user_id, project_id) => {
	const fileslist = await Storage.list(`project/${project_id}`, {
		level: "protected",
		identityId: user_id
	})
	return Promise.all(
		fileslist.map(data => {
			return Storage.get(data.key, {
				level: "protected",
				identityId: user_id,
				download: true
			})
				.then(result => ({
					...result,
					Body: result.Body.toString(),
					RawBody: result.Body,
					Key: data.key
				}))
				.catch(err => {})
		})
	)
}

export const putFiles = async (project_id, fileObj, cols) => {
	await Storage.put(`project/${project_id}/${fileObj.path}`, fileObj, {
		level: "protected",
		contentType: `${fileObj.type}`,
		metadata: {
			name: cols.name,
			type: cols.type,
			dataCol: JSON.stringify(cols.dataCol)
		}
	})
}

export const updateFiles = async (project_id, fileUpdate, idx) => {
	await Storage.put(
		`project/${project_id}/${fileUpdate.Metadata["name"]}.${fileUpdate.Metadata["type"]}`,
		fileUpdate.RawBody,
		{
			level: "protected",
			contentType: `${fileUpdate.ContentType}`,
			metadata: {
				name: fileUpdate.Metadata["name"],
				type: fileUpdate.Metadata["type"],
				dataCol: JSON.stringify(fileUpdate.Metadata.datacol)
			}
		}
	)
	return { fileUpdate, idx }
}

export const deleteFiles = async (project_id, Files) => {
	await Storage.remove(
		`project/${project_id}/${Files.Metadata["name"]}.${Files.Metadata["type"]}`,
		{
			level: "protected"
		}
	)
}

export const uploadImage = async ({ user_id, image }) => {
	return await Storage.put(`${user_id}/profile/image/${image["name"]}`, image, {
		level: "public",
		acl: "public-read",
		contentType: image["type"]
	})
		.then(data => {
			return data["key"]
		})
		.catch(err => {})
}
